import React from 'react';
import PropTypes from 'prop-types';

import InternalLinking from './InternalLinking';

const getInternalLinkingContainer = pageName => {
  const InternalLinkingContainer = (props, { data }) => (
    <InternalLinking {...data[pageName].internalLinking} {...props} />
  );

  InternalLinkingContainer.contextTypes = {
    data: PropTypes.shape({
      [pageName]: PropTypes.shape({
        internalLinking: PropTypes.shape({
          allCities: PropTypes.arrayOf(PropTypes.string).isRequired,
          countryCities: PropTypes.arrayOf(PropTypes.string).isRequired,
          countryCode: PropTypes.string.isRequired,
          areaSlug: PropTypes.string.isRequired,
          seoLinks: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string.isRequired,
              url: PropTypes.string.isRequired
            })
          )
        })
      })
    })
  };

  return InternalLinkingContainer;
};

export default getInternalLinkingContainer;
